import styled from 'styled-components';
import { theme } from '../../../styles/theme';

export const Section = styled.section`
  padding: 6rem 8%;
  background: ${theme.colors.bgLight};
`;

export const Header = styled.div`
  text-align: center;
`;

export const SectionTag = styled.span`
  display: inline-block;
  color: ${theme.colors.orange};
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  margin-bottom: 0.75rem;
`;

export const SectionTitle = styled.h2`
  font-family: ${theme.fonts.display};
  font-size: clamp(2rem, 3.5vw, 2.9rem);
  font-weight: 800;
  line-height: 1.05;
  letter-spacing: -0.03em;
  color: ${theme.colors.black};
  margin-bottom: 1rem;
`;

export const SectionSub = styled.p`
  color: ${theme.colors.mid};
  font-size: 1rem;
  line-height: 1.7;
  max-width: 540px;
  font-weight: 400;
  margin-left: auto;
  margin-right: auto;
`;

export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1.5rem;
  margin-top: 3.5rem;

  @media (max-width: 960px) {
    grid-template-columns: 1fr 1fr;
  }

  @media (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`;

export const Card = styled.div`
  background: white;
  border-radius: 20px;
  padding: 2rem;
  border: 1px solid ${theme.colors.border};
  transition: transform 0.3s, box-shadow 0.3s, border-color 0.3s;
  position: relative;
  overflow: hidden;

  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 3px;
    background: linear-gradient(90deg, ${theme.colors.orange}, #ffa07a);
    transform: scaleX(0);
    transform-origin: left;
    transition: transform 0.3s;
  }

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 12px 40px rgba(0, 0, 0, 0.08);
    border-color: transparent;

    &::after {
      transform: scaleX(1);
    }
  }
`;

export const FeatIcon = styled.div`
  width: 48px;
  height: 48px;
  background: ${theme.colors.orangeLight};
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.3rem;
  margin-bottom: 1.2rem;
`;

export const CardTitle = styled.h3`
  font-family: ${theme.fonts.display};
  font-size: 1rem;
  font-weight: 700;
  color: ${theme.colors.black};
  margin-bottom: 0.6rem;
`;

export const CardText = styled.p`
  color: ${theme.colors.mid};
  font-size: 0.88rem;
  line-height: 1.65;
`;
